<template>
<!-- An header containing a logo, a title and a language picker -->
<!-- Parent must implement `changeLang(item)` -->
  <header id="stickyheader">
    <div id="logoContainer" v-on:click="changeLeftMenuState()">
      <svg id="logo" xmlns="http://www.w3.org/2000/svg"  fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
      </svg>
    </div>
    <div id="title-container">
      <h1>{{ title }}</h1>
    </div>
    <div id="langPickerContainer">
      <!-- <langage-picker v-bind:lang="lang"></langage-picker> -->
    </div>
  </header>
</template>

<script>
// import LangagePicker from './LangagePicker.vue'

export default {
  name: 'StickyHeader',
  components : {
    // LangagePicker
  },
  props: {
    title: String,
    lang : String,
    hideMenu : Boolean
  },
  methods : {
    /**
     * Triggered by language picker when a language
     * is selected
     * 
     * @param newLang : Either 'en', 'fr' or 'nl'
     */
    changeLang(newLang){
      this.$parent.changeLang(newLang);
    },
    /**
     * Triggered when user clicks on burger button
     */
    changeLeftMenuState(){
      this.$parent.changeLeftMenuState();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#stickyheader {
  overflow: hidden;
  background-color: #00214e;
  position: fixed;
  top: 0;
  width: 100%;
  min-width: 10px;
  height: 8vh;
  display: flex;
  justify-content: space-between;
  z-index: 100;
}

#logoContainer  {
  visibility: hidden;
  width: 15vw;
  min-height: 8vh;
  margin-top : auto;
  margin-bottom: auto;
  margin-left : 2% ;
  color : rgba(255, 255, 255, 0.8);
}


#logo {
  width: 100%;
  height: 100%;
  display: block;
}

#title-container {
  height: 3vh;
  width: 100%;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
}

#title-container h1 {
  color: rgba(255, 255, 255, 0.8);
  font-size: 200%;
  display: block;
}



#langPickerContainer {
  /* display : block; */
  width: 15vw;
  margin-top: auto;
  margin-bottom: auto;
  height: 1.7rem;
  max-height: 100%;
  color : rgba(255, 255, 255, 0.8);
}

/* Phone display */
@media screen and (max-width: 850px) and (orientation: portrait) {

  #stickyheader {
    width: 100vw;
  }

  #logoContainer {
    width: 10vw;
    cursor : pointer;
    visibility: visible;
  }

  #title-container {
    width: 60%;
    max-height: 100%;
    height: 50%;
  }

  #title-container h1 {
    font-size: 3vw;
  }


  #langPickerContainer {
    height: auto;
    width: 15vw;
    font-size: 75%;
  }
}

@media screen and (max-width: 850px) and (orientation: landscape) {
  #logoContainer {
    width: 5vw;
    cursor : pointer;
    visibility: visible;
  }
}

/* Set max font size */
@media screen and (max-height: 500px) {
  
  #title-container {
    height: 8vh;
  }

  #title-container h1 {
    font-size: 8vh;
  }
}

</style>
